import { createElement } from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "libraries/serviceWorker";

import { Root } from "Root";

const siteEnvironment = (window as any).siteEnvironment ?? {};
const debug = process.env.REACT_APP_DEBUG !== undefined ? true : false;
const development = process.env.NODE_ENV === "development" ? true : false;

const props = { debug, siteEnvironment };
ReactDOM.render(createElement(Root, props), document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// Enable HMR
if (module.hot && development) {
  module.hot.accept();
}
